import styled from 'styled-components';

export const ModalOverlay = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background-color: rgba(0, 0, 0, 0.5);
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 1000;
	padding: 20px;
	box-sizing: border-box;
`;

export const ModalContent = styled.div`
	position: relative;
	background-color: #ffffff;
	border-radius: 8px;
	width: 100%;
	max-width: 900px;
	max-height: 90vh;
	overflow-y: auto;
	box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
`;

export const CloseButton = styled.button`
	position: absolute;
	top: 16px;
	right: 16px;
	background: none;
	border: none;
	cursor: pointer;
	padding: 8px;
	border-radius: 4px;
	color: ${({ theme }) => theme.gray['200']};
	transition: all 0.2s ease-in-out;
	z-index: 10;

	&:hover {
		background-color: ${({ theme }) => theme.gray['900']};
	}

	svg {
		display: block;
	}
`;

export const Content = styled.div`
	display: flex;
	flex-direction: row;
	gap: 40px;
	padding: 40px;

	@media (max-width: 768px) {
		flex-direction: column;
		gap: 30px;
		padding: 30px 20px;
	}
`;

export const LeftColumn = styled.div`
	display: flex;
	flex-direction: column;
	flex: 1;
	gap: 20px;
	box-sizing: border-box;

	@media (max-width: 768px) {
		gap: 16px;
	}
`;

export const RightColumn = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	flex-shrink: 0;
	width: 280px;

	img {
		width: 100%;
		height: auto;
		max-width: 280px;
	}

	@media (max-width: 768px) {
		width: 100%;
		max-width: 200px;
		margin: 0 auto;

		img {
			max-width: 200px;
		}
	}
`;

export const Headline = styled.div`
	font-size: 48px;
	font-family: 'F37Judge-MediumCondensed', sans-serif;
	line-height: 1.1;
	color: ${({ theme }) => theme.gray['0']};

	@media (max-width: 768px) {
		font-size: 36px;
	}
`;

export const Body = styled.div`
	font-size: 20px;
	font-family: 'Inter', sans-serif;
	line-height: 1.45;
	letter-spacing: -0.02em;
	color: ${({ theme }) => theme.gray['0']};

	@media (max-width: 768px) {
		font-size: 16px;
		line-height: 1.5;
	}
`;

export const ButtonContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 12px;
	margin-top: 20px;

	@media (max-width: 768px) {
		margin-top: 16px;
		gap: 10px;
	}
`;

export const PrimaryButton = styled.button`
	background-color: ${({ theme }) => theme.green['800']};
	color: ${({ theme }) => theme.gray['100']};
	border: 2px solid ${({ theme }) => theme.gray['900']};
	font-family: 'Inter', sans-serif;
	font-size: 18px;
	font-weight: 500;
	padding: 12px 24px;
	height: 48px;
	cursor: pointer;
	transition: all 0.2s ease-in-out;
	border-radius: 4px;
	width: 100%;

	&:hover {
		background-color: ${({ theme }) => theme.green['800']};
		border-color: ${({ theme }) => theme.gray['600']};
	}

	&:active {
		background-color: ${({ theme }) => theme.green['600']};
		border-color: ${({ theme }) => theme.gray['700']};
	}

	@media (max-width: 768px) {
		font-size: 16px;
		height: 44px;
		padding: 10px 20px;
	}
`;

export const SecondaryButton = styled.button`
	background-color: transparent;
	color: ${({ theme }) => theme.gray['0']};
	border: 2px solid ${({ theme }) => theme.gray['800']};
	font-family: 'Inter', sans-serif;
	font-size: 18px;
	font-weight: 500;
	padding: 12px 24px;
	height: 48px;
	cursor: pointer;
	transition: all 0.2s ease-in-out;
	border-radius: 4px;
	width: 100%;

	&:hover {
		background-color: ${({ theme }) => theme.gray['900']};
	}

	&:active {
		border-color: ${({ theme }) => theme.gray['700']};
		// background-color: ${({ theme }) => theme.gray['200']};
	}

	@media (max-width: 768px) {
		font-size: 16px;
		height: 44px;
		padding: 10px 20px;
	}
`;

export const FooterText = styled.div`
	font-size: 16px;
	font-family: 'Inter', sans-serif;
	line-height: 1.45;
	color: ${({ theme }) => theme.gray['100']};
	margin-top: 20px;

	@media (max-width: 768px) {
		font-size: 14px;
		margin-top: 16px;
	}
`;

export const EmailLink = styled.a`
	font-family: 'Inter', sans-serif;
	font-weight: 600;
	color: ${({ theme }) => theme.gray['0']};
	text-decoration: none;
	transition: opacity 0.2s ease-in-out;

	&:hover {
		opacity: 0.7;
	}
`;
